import { HttpEvent, HttpHandlerFn, HttpRequest, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import store from 'store2';
import { NMI_CONFIG } from '@cmbsolutions/nmi-angular';

// Interceptor function with correct signature
export const AuthIInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const token = store('token');
  const router = inject(Router);
  const nmiConfig = inject(NMI_CONFIG, { optional: true });
  let clonedReq = req;
  if (token) {
    clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    //return next(clonedReq);  // Call next with the cloned request
  }
  return next(clonedReq).pipe(
    catchError((error) => {
      if (error.status === 401) {
        // NMI API 401 means JWT rejected by NMI - do not log the user out of this app
        const isNmiRequest = nmiConfig && req.url.startsWith(nmiConfig.apiUrl);
        if (!isNmiRequest) {
          localStorage.removeItem('token'); // Removing the token
          router.navigate(['/login']).then(()=> window.location.reload()); // Redirecting to login page
        }
      }
      // return throwError(() => console.error("No token", error));
      return throwError(() => error);
    })
  );
};
